module.exports = __webpack_public_path__ + "media/images/blog_pdf-c1c421d807c414db48cf85ec146181c7.jpg";